import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from "react-redux"
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import { DebounceInput } from 'react-debounce-input'

import { SET_FILTER_DATA } from "store/filterData/actions"
import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PaymentModal from '../../../components/PaymentModal'

import { httpOk, GET, POST, DELETE, FILE_D } from 'helpers/api'
import {
	formatMoney, returnSign, findKeyFromArrayByValue,
	formatDate, getCurrentChequeDate, chequeDates
} from 'helpers/helpers'

import CustomTooltip from "pages/parts/CustomTooltip"

function Index() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const date = new Date()

	const reduxAccount = useSelector(state => state.account)
	const reduxSettings = useSelector(state => state.settings)

	const transactionTypes = [
		{ 'id': 'plus', 'name': t('income') },
		{ 'id': 'minus', 'name': t('expense') },
	]

	const statuses = [
		{ 'id': 1, 'name': t('success') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const [selectedItem, setSelectedItem] = useState({
		'payment_purpose_id': 6,
		'amount': '',
		'note': '',
		'created_at': formatDate(date, 'yyyy-MM-dd'),
	});
	const [modalExpense, setModalExpense] = useState(false);
	const [modalCounterparty, setModalCounterparty] = useState(false);
	const [counterparties, setCounterparties] = useState([])
	const [accounts, setAccounts] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [paymentPurposeTypes, setPaymentPurposeTypes] = useState([])
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [conversionModal, setConversionModal] = useState(false)

	const [filterData, setFilterData] = useState({
		'start_date': formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		'end_date': formatDate(new Date(), 'yyyy-MM-dd'),
		'status': 1,
		'pos_id': reduxAccount?.pos_id,
		'search': '',
	})
	const [pagination, setPagination] = useState({
		url: '/report-expenses',
		response: null
	})
	const [data, setData] = useState([])


	async function searchWithFilter(settings = {}) {
		var filterUrl = "/report/expenses"
		var urlParams = ""
		checkFilter()

		// var filterDataCopy = { ...filterData }
		// if (settings?.reduxData) {
		// 	filterDataCopy = reduxFilterData
		// }

		// // if (filterDataCopy.pos_id)
		// // 	urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		// // if (filterDataCopy.status)
		// // 	urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		// // if (filterDataCopy.payment_purpose_id)
		// // 	urlParams += returnSign(urlParams) + 'payment_purpose_id=' + filterDataCopy.payment_purpose_id
		// // if (filterDataCopy.created_by)
		// // 	urlParams += returnSign(urlParams) + 'created_by=' + filterDataCopy.created_by
		// // if (filterDataCopy.account_chef_id)
		// // 	urlParams += returnSign(urlParams) + 'account_chef_id=' + filterDataCopy.account_chef_id
		// // if (filterDataCopy.start_date)
		// // 	urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		// // if (filterDataCopy.end_date)
		// // 	urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		// // if (filterDataCopy.search)
		// // 	urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		// // if (filterDataCopy.page)
		// // 	urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/report/expenses${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function deleteItem() {
		const response = await DELETE(`/expense-web/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			toggleModalDelete(false)
		}
	}

	async function downloadExcelFile() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/report/expenses"
		var urlParams = "?excel=true"

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.payment_purpose_id)
			urlParams += returnSign(urlParams) + 'payment_purpose_id=' + filterDataCopy.payment_purpose_id
		if (filterDataCopy.created_by)
			urlParams += returnSign(urlParams) + 'created_by=' + filterDataCopy.created_by
		if (filterDataCopy.user_login)
			urlParams += returnSign(urlParams) + 'category_id=' + filterDataCopy.category_id
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search

		filterDataCopy.urlParams = urlParams

		filterUrl = filterUrl + urlParams
		var response = await FILE_D(filterUrl)

		if (httpOk(response)) {
			// Создаем объект Blob из полученного файла
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

			// Создаем ссылку для скачивания файла
			const fileUrl = URL.createObjectURL(file);

			// Создаем ссылку для скачивания файла в браузере
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', `${t('expenses')}.xlsx`);
			document.body.appendChild(link);
			link.click();

			// Удаляем ссылку после скачивания файла
			URL.revokeObjectURL(fileUrl);
		}
	};

	function resetFilter() {
		setFilterData({
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			pos_id: null,
			search: '',
		})
		setFilterDataExist(false)
		searchWithFilter()
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id })
	}


	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function conversionCreate(e) {
		e.preventDefault()

		var response = await POST('/accounts/conversion', selectedItem, { loader: true });

		if (httpOk(response)) {
			toggleConversionModal(false)
			searchWithFilter()
		}
	}

	function handleChangePayment(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[e.target.name] = e.target.value.replace(/[^0-9.]/g, '');
		if (e.target.name === 'amount_usd') {
			selectedItemCopy['amount'] = selectedItemCopy['amount_usd'] * Number(selectedItemCopy.currency);
		}
		if (e.target.name === 'amount') {
			selectedItemCopy['currency'] = selectedItemCopy['amount'] / selectedItemCopy['amount_usd'];
		}
		if (e.target.name === 'currency') {
			selectedItemCopy['amount'] = selectedItemCopy['amount_usd'] * Number(selectedItemCopy.currency);
		}
		setSelectedItem(selectedItemCopy)
	}

	function toggleConversionModal(bool = false, item = {}) {
		item.currency = reduxSettings.currency;
		setConversionModal(bool)
		setSelectedItem(item)
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function toggleModal(bool, item = {}) {
		if (bool) {
			setSelectedItem(item)
		} else {
			setSelectedItem({
				'pos_id': reduxAccount.pos_id,
				'payment_purpose_id': 6,
				'amount': '',
				'note': '',
				'created_at': formatDate(date, 'yyyy-MM-dd HH:mm'),
			})
		}

		setModalExpense(bool)
	}

	function toggleModalDelete(bool = false, id = null) {
		if (bool) setDeleteModalParams({ 'id': id })

		setModalDelete(bool)
	}

	async function getClients(search = "") {
		var urlParams = ""

		if (search)
			urlParams += returnSign(urlParams) + 'search=' + search

		const response = await GET(`/search-clients${urlParams}`, {}, { loader: true })
		if (httpOk(response)) setCounterparties(response.data)
	}

	function handleCounterparty(option) {
		setSelectedItem({ ...selectedItem, 'counterparty_id': option ? option.id : null })
		setModalCounterparty(false)
	}

	async function getPaymentPurposeTypes() {
		const response = await GET('/helper/ppt-expense')
		if (httpOk(response)) setPaymentPurposeTypes(response.data)
	}

	async function getCashiers() {
		const response = await GET('/helper/cashiers')
		if (httpOk(response)) setCashiers(response.data)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	useEffect(() => {
		getAccounts()
		getPaymentPurposeTypes()
		getCashiers()

		return () => {
			dispatch(SET_FILTER_DATA({}))
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('income_expense')} [{pagination?.response?.total}]
				</h4>

				<div className="d-flex gap-2">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleConversionModal(true)}>
						{t('conversion')}
					</button>

					<button className="btn-rounded btn btn-primary"
						onClick={() => setModalExpense(true)}>
						{t('add')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											{/* <div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div> */}
											<div className="form-group col-md-6">
												<label>{t('accounts')}</label>
												<Select
													isClearable
													options={accounts}
													value={accounts.find(option => option.id === filterData.account_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'account_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('transaction_type')}</label>
												<Select
													isClearable
													options={transactionTypes}
													value={transactionTypes.find(option => option.id === filterData.transaction_type) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'transaction_type': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('type')}</label>
												<Select
													isClearable
													options={paymentPurposeTypes}
													value={paymentPurposeTypes.find(option => option.id === filterData.payment_purpose_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'payment_purpose_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											{/* <div className="form-group col-md-6">
												<label>{t('user')}</label>
												<Select
													isClearable
													options={cashiers}
													value={cashiers.find(option => option.login === filterData.created_by) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'created_by': option ? option.login : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.login}
												/>
											</div> */}
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide-2"
									title="EXCEL"
									onClick={() => downloadExcelFile()}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
						{/* <div className="vertical-center">
							<h4><b>{t('amount')}</b>: {formatMoney(data.total_amount)}</h4>
						</div> */}
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{filterData.created_by &&
									<span className="me-2">
										<b>{t('user')}: </b>
										{findKeyFromArrayByValue(cashiers, 'login', filterData.created_by, 'first_name')}
									</span>
								}
								{filterData.payment_purpose_id &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{findKeyFromArrayByValue(paymentPurposeTypes, 'id', filterData.payment_purpose_id, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '10%' }}>{t('user')}</th>
									<th style={{ 'width': '10%' }}>{t('account')}</th>
									<th style={{ 'width': '10%' }}>{t('payment_type')}</th>
									<th style={{ 'width': '15%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('counterparty')}</th>
									<th style={{ 'width': '10%' }}>{t('name')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'width': '15%' }}>{t('note')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center text-nowrap">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-end text-nowrap"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis" title={item.created_by}>{item.created_by}</td>
										<td className="td-ellipsis">{item.account_name}</td>
										<td className="td-ellipsis" title={item.payment_type_name}>{item.payment_type_name}</td>
										<td className="td-ellipsis" title={item.payment_purpose_name}>{item.payment_purpose_name}</td>
										<td className="td-ellipsis" title={t(item.counterparty)}>{t(item.counterparty)}</td>
										<td className="td-ellipsis" title={t(item.counterparty_name)}>{t(item.counterparty_name)}</td>
										<td className="td-ellipsis">{t(item.entity_type)}</td>
										<td className="td-ellipsis">
											<CustomTooltip text={item.note}>
												{item.note}
											</CustomTooltip>
										</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className={`text-end ${item.transaction_type === 'plus' ? 'text-success' : 'text-danger'}`}>{formatMoney(item.amount)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteModalParams({ id: item.id, index: index });
																setModalDelete(true)
															}}>
															<i className="uil uil-times"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL PAYMENT */}
			<PaymentModal modalExpense={modalExpense} toggleModal={toggleModal} searchWithFilter={searchWithFilter} />
			{/* MODAL PAYMENT */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			{/* EXPENSE MODAL CLIENT */}
			<Modal show={modalCounterparty} animation={false}
				centered size="lg"
				onHide={() => setModalCounterparty(false)}>
				<Modal.Body style={{ 'padding': '0' }}>
					<div style={{ 'height': '415px', 'overflow': 'auto', 'padding': '15px' }}>
						<div className="d-flex flex-wrap gap-2">
							{counterparties.map((item, index) => (
								<button key={index} className="order-actions-item"
									style={{ 'width': '32%' }}
									onClick={() => handleCounterparty(item)}>
									<div className="d-flex flex-column">
										<span>{item.name}</span>
										<span>{item.phone}</span>
									</div>
									<span style={{
										'position': 'absolute',
										'right': '5px',
										'bottom': '2px',
										'fontSize': '13px',
									}}>
										{item?.balance < 0 &&
											<span className="text-danger">{formatMoney(item?.balance)}</span>
										}
									</span>
								</button>
							))}
						</div>
					</div>
					<div style={{
						'display': 'flex',
						'backgroundColor': '#fff',
						'height': '60px',
						'borderTop': '1px solid #DFE3E7',
						'width': '100%',
					}}>
						<div className="d-flex justify-content-between w-100">
							<DebounceInput
								style={{
									'width': '300px',
									'borderRadius': '0',
								}}
								//value={filterData.search}
								type="text"
								className="form-control"
								placeholder={t('search') + '...'}
								minLength={2}
								debounceTimeout={1000}
								onChange={(e) => getClients(e.target.value)}
							/>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* EXPENSE MODAL CLIENT */}

			{/* MODAL PAYMENT */}
			<Modal show={conversionModal} animation={false}
				centered dialogClassName="update-modal-width"
				backdrop="static" onHide={() => toggleConversionModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('conversion')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={conversionCreate} autoComplete="off">
						<div className="form-group">
							<label>{t('from_account')}</label>
							<Select
								options={accounts}
								value={accounts?.find(option => option.id === selectedItem.from_account_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'from_account_id': option?.id, 'from_account_is_usd': option.is_usd })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('to_account')}</label>
							<Select
								options={accounts.filter(item => item.id !== selectedItem.from_account_id)}
								value={accounts.filter(item => item.id !== selectedItem.from_account_id).find(option => option.id === selectedItem.to_account_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'to_account_id': option.id, 'to_account_is_usd': option.is_usd })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
								isDisabled={!selectedItem.from_account_id}
							/>
						</div>
						<div className="row">
							<div className="col-md-4">
								<div className="form-group">
									<label>{t('amount_usd')}<span className="required-mark">*</span></label>
									<input type="text" className="form-control" name="amount_usd"
										value={selectedItem.amount_usd ? formatMoney(selectedItem.amount_usd) : ''}
										onChange={(e) => handleChangePayment(e)} />
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-group">
									<label>{t('rate')}<span className="required-mark">*</span></label>
									<input type="text" className="form-control" name="currency"
										value={selectedItem.currency ? formatMoney(selectedItem.currency) : ''}
										onChange={(e) => handleChangePayment(e)} />
								</div>
							</div>
							<div className="col-md-4">
								<div className="form-group">
									<label>{t('amount')}<span className="required-mark">*</span></label>
									<input type="text" className="form-control" name="amount"
										value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
										onChange={(e) => handleChangePayment(e)} />
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleConversionModal(false)} tabIndex="-1">
								{t('cancel')}
							</button>
							{selectedItem.id ?
								<button type="submit" className="btn btn-primary w-100"
									disabled={!selectedItem.amount}>
									{t('save')}
								</button>
								:
								<button type="submit" className="btn btn-primary w-100">
									{t('save')}
								</button>
							}
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT */}

		</>
	)
}

export default Index